import { IDossierItem } from "dto/Dossier/IDossierItem";
import { create } from "zustand";

export const useDossierStore = create((set) => ({
  selectedItems: [] as IDossierItem[],
  setSelectedItems: (newState: IDossierItem[]) => {
    set((state) => ({ ...state, selectedItems: newState }));
  },
}));
